import Bone from 'src/components/Loaders/Bone'

/** Sidebar / tab-bar placeholder while dashboardContext resolves — spec §10. */
export default function NavSkeleton({
  rows,
  collapsed = false
}: {
  rows: number
  collapsed?: boolean
}) {
  return (
    <ul className="m-0 flex list-none flex-col gap-1 p-0" aria-hidden>
      {Array.from({ length: rows }).map((_, i) => (
        <li
          key={i}
          className={`flex h-10 items-center gap-3 px-3 ${collapsed ? 'justify-center' : ''}`}
        >
          <Bone className="size-[18px] rounded" />
          {!collapsed && <Bone className="h-3 w-24 rounded" />}
        </li>
      ))}
    </ul>
  )
}
